import React, { useEffect, useRef } from "react";

import { TailwindInput } from "../../Tailwind";
import { useUpdateFieldValue } from "../../../shared/hooks/mutations/useUpdateFieldValue";
import { updateFieldValue } from "../../../shared/api/fields";
import { useSaveIndicator } from "../../../hooks/useSaveIndicator";
import SaveIndicator from "../../SaveIndicator";
import { useEditorStore } from "../../../shared/stores/useEditorStore";


export default function StringField({ name, field }) {
    // Gérer le cas où currentValue est undefined (nouveau model data)
    const safeCurrentValue = field.currentValue?.value ?? field.value?.value ?? '';

    const [fieldValue, setFieldValue] = React.useState(safeCurrentValue);
    const [initialValue, setInitialValue] = React.useState(safeCurrentValue);
    const { status: saveStatus, trigger: triggerSave, resolve: resolveSave } = useSaveIndicator();
    const updateField = useUpdateFieldValue();
    const isReadOnly = !useEditorStore(s => s.userRights.right_to_write);
    const scenarioId = useEditorStore(s => s.scenarioId);

    // Refs for saving unsaved changes on unmount
    const fieldValueRef = useRef(fieldValue);
    const initialValueRef = useRef(initialValue);
    const fieldIdRef = useRef(field.id);
    const isSavingRef = useRef(false);
    fieldValueRef.current = fieldValue;
    initialValueRef.current = initialValue;
    fieldIdRef.current = field.id;

    // Save unsaved changes when the component unmounts (e.g. selecting another model_data)
    useEffect(() => {
        return () => {
            if (!isSavingRef.current && fieldValueRef.current != initialValueRef.current) {
                updateFieldValue(fieldIdRef.current, fieldValueRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const newValue = field.currentValue?.value ?? field.value?.value ?? '';
        setFieldValue(newValue);
    }, [field.currentValue?.value, field.value?.value])

    const handleChange = (e) => {
        field.compute_error = null;
        const newValue = e.target.value;

        if (field.currentValue) {
            field.currentValue.value = newValue;
        }
        setFieldValue(newValue);
    }

    const validate = (e) => {
        const newValue = e.target.value;
        const currentVal = field.currentValue?.value ?? field.value?.value ?? '';

        if (currentVal != initialValue)
        {
            isSavingRef.current = true;
            triggerSave();
            updateField.mutate(
                { id: field.id, value: newValue, scenarioId: scenarioId ?? 0 },
                {
                    onSuccess: () => {
                        setInitialValue(newValue);
                        resolveSave();
                        isSavingRef.current = false;
                    },
                    onError: () => {
                        isSavingRef.current = false;
                    },
                }
            );
        }
    }

    return (
        <div className="flex flex-row items-center mb-1">
            <TailwindInput
                value={fieldValue}
                placeholder={name}
                suffix={field.suffix}
                readOnly={isReadOnly}
                onChange={handleChange}
                onBlur={validate}
                error={field.compute_error}
                helperText={field.compute_error}
                className="h-10 w-[200px]"
            />
            <SaveIndicator status={saveStatus} className="ml-2" />
        </div>
    )
}
